"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvoiceCommunicationMethod = exports.AddressTypeId = exports.CarrierMethod = exports.ShippingType = exports.AddressType = exports.UnloadByCode = exports.TruckUnloadCode = exports.PartialShipmentDescription = exports.AddressCategoryId = exports.AddressCategory = exports.UnloadBy = exports.TruckUnload = void 0;
var TruckUnload;

(function (TruckUnload) {
  TruckUnload["REAR"] = "Rear";
  TruckUnload["SIDE"] = "Side";
})(TruckUnload || (exports.TruckUnload = TruckUnload = {}));

var UnloadBy;

(function (UnloadBy) {
  UnloadBy["FORKLIFT"] = "Forklift";
  UnloadBy["OVERHEAD"] = "Overhead Crane";
})(UnloadBy || (exports.UnloadBy = UnloadBy = {}));

var AddressCategory;

(function (AddressCategory) {
  AddressCategory["SoldTo"] = "SoldTo";
  AddressCategory["ShipTo"] = "ShipTo";
  AddressCategory["BillTo"] = "BillTo";
  AddressCategory["AdditionalShipTo"] = "ShipTo";
})(AddressCategory || (exports.AddressCategory = AddressCategory = {}));

var AddressCategoryId;

(function (AddressCategoryId) {
  AddressCategoryId[AddressCategoryId["SoldTo"] = 1] = "SoldTo";
  AddressCategoryId[AddressCategoryId["ShipTo"] = 2] = "ShipTo";
  AddressCategoryId[AddressCategoryId["BillTo"] = 3] = "BillTo";
})(AddressCategoryId || (exports.AddressCategoryId = AddressCategoryId = {}));

var PartialShipmentDescription;

(function (PartialShipmentDescription) {
  PartialShipmentDescription["OkayToShip"] = "Okay to ship as available";
  PartialShipmentDescription["HoldToShip"] = "Hold to ship order complete";
})(PartialShipmentDescription || (exports.PartialShipmentDescription = PartialShipmentDescription = {}));

var TruckUnloadCode;

(function (TruckUnloadCode) {
  TruckUnloadCode["REAR"] = "R";
  TruckUnloadCode["SIDE"] = "S";
})(TruckUnloadCode || (exports.TruckUnloadCode = TruckUnloadCode = {}));

var UnloadByCode;

(function (UnloadByCode) {
  UnloadByCode["FORKLIFT"] = "F";
  UnloadByCode["OVERHEAD"] = "O";
})(UnloadByCode || (exports.UnloadByCode = UnloadByCode = {}));

var AddressType;

(function (AddressType) {
  AddressType["Business"] = "Business";
  AddressType["Residential"] = "Residential";
})(AddressType || (exports.AddressType = AddressType = {}));

var ShippingType;

(function (ShippingType) {
  ShippingType["standard"] = "RC";
  ShippingType["customerPickup"] = "WC";
})(ShippingType || (exports.ShippingType = ShippingType = {}));

var CarrierMethod;

(function (CarrierMethod) {
  CarrierMethod["CustomerPickUp"] = "Customer Pick up";
  CarrierMethod["StandardShipping"] = "Standard Shipping";
})(CarrierMethod || (exports.CarrierMethod = CarrierMethod = {}));

var AddressTypeId;

(function (AddressTypeId) {
  AddressTypeId[AddressTypeId["Business"] = 1] = "Business";
  AddressTypeId[AddressTypeId["Residential"] = 2] = "Residential";
})(AddressTypeId || (exports.AddressTypeId = AddressTypeId = {}));

var InvoiceCommunicationMethod;

(function (InvoiceCommunicationMethod) {
  InvoiceCommunicationMethod["Email"] = "E-mail";
  InvoiceCommunicationMethod["USMail"] = "US Mail";
  InvoiceCommunicationMethod["Fax"] = "Fax";
})(InvoiceCommunicationMethod || (exports.InvoiceCommunicationMethod = InvoiceCommunicationMethod = {}));